import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    contract,
    contractDate,

    address,
    authDocument,
    authDocumentDate,
    checkbox1,
    checkbox2,
    contactAddress,
    contractCode,
    district,
    email,
    email2,
    fax,
    fax2,
    field01a,
    field01b,
    field01c,
    field01d,
    identity,
    organizationName,
    passport,
    phone,
    phone2,
    province,
    taxId2,
    ward,
  },
} = checkout;

const initialValues = {
  [contract.name]: "",
  [contractDate.name]: "",
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [address.name]: "",
  [authDocument.name]: "",
  [authDocumentDate.name]: "",
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [contactAddress.name]: "",
  [contractCode.name]: "",
  [district.name]: "",
  [email.name]: "",
  [email2.name]: "",
  [fax.name]: "",
  [fax2.name]: "",
  [field01a.name]: "",
  [field01b.name]: "",
  [field01c.name]: "",
  [field01d.name]: "",
  [identity.name]: "",
  [organizationName.name]: "",
  [passport.name]: "",
  [phone.name]: "",
  [phone2.name]: "",
  [province.name]: "",
  [taxId2.name]: "",
  [ward.name]: "",
};

export default initialValues;
